import { render, staticRenderFns } from "./presentaciones.vue?vue&type=template&id=5eea5ee1"
import script from "./presentaciones.vue?vue&type=script&lang=js"
export * from "./presentaciones.vue?vue&type=script&lang=js"
import style0 from "./presentaciones.vue?vue&type=style&index=0&id=5eea5ee1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports